import React, { forwardRef, useState, useEffect } from 'react';
import '../styles/InputDescription.css';

const Description = forwardRef(({ value, onChange, placeholder, minLength, maxLength, label, height, onEnter, disabled = false }, ref) => {

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && onEnter) {
      onEnter();
    }
  };

  const handleChange = (e) => {
    const text = e.target.value;
    if(onChange) {
        onChange(text);
    }
  };

  return (
    <div className="description-wrapper" style={{ height: height }}>
      {label && <label className="description-label">{label}</label>}
      <textarea
        ref={ref}
        className="description-textarea"
        value={value}
        minLength={minLength}
        maxLength={maxLength}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder={placeholder}
      />
    </div>
  );
});

export default Description;